<template>
    <div class="dark">
    </div>
</template>

<script>
export default {
    name:'Darksceen'
}
</script>

<style>
    .dark{
        
        position: fixed;
        width: 100%;
        height: 100%;
        background: black;
    }
</style>



// WEBPACK FOOTER //
// src/components/Dark.vue